import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import { RESETTING } from "./constant/url-segment"
import { ResettingRequestBody } from "./request-body"
import { RepeatedPassword, User } from "../../model"

const resettingBaseUrl = `${apiBaseUrl}/${RESETTING}`

export function resetPassword(
	token: string,
	password: RepeatedPassword
): Promise<User> {
	const resetting: ResettingRequestBody = {
		resetting: { plainPassword: password }
	}
	const body = JSON.stringify(resetting)
	const url = `${resettingBaseUrl}/reset/${token}`
	const init: RequestInit = {
		body,
		headers: { "Content-Type": "application/json" },
		method: "POST"
	}

	return genericFetch<User>(url, init)
}


// WEBPACK FOOTER //
// ./src/service/sfp/resetting-service.ts